"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIME_ZONE = void 0;
const TIME_ZONE = exports.TIME_ZONE = {
  UTC: "UTC",
  AmericaSP: "America/Sao_Paulo"
};